/**
 * Generated from BadgePopup.fla
 */
export function BadgePopup(this: IBadgePopup) {
	const trashSticker = this.trashSticker;
	if (!trashSticker[0] && trashSticker.elementFactory) {
		trashSticker[0] = trashSticker.elementFactory(0,undefined);
	}
	if (trashSticker[0]) {
		BadgePopup_recyclingSticker.call(trashSticker[0] as IBadgePopup_recyclingSticker);
		trashSticker[0].x = 778.75;
		trashSticker[0].y = 266;
		trashSticker[0].width = 127.50;
		trashSticker[0].height = 128.00;
		if (trashSticker[0].onLayout) trashSticker[0].onLayout();
	}
	if (!trashSticker[1] && trashSticker.elementFactory) {
		trashSticker[1] = trashSticker.elementFactory(1,undefined);
	}
	if (trashSticker[1]) {
		BadgePopup_bananaSticker.call(trashSticker[1] as IBadgePopup_bananaSticker);
		trashSticker[1].x = 778.75;
		trashSticker[1].y = 266;
		trashSticker[1].width = 127.50;
		trashSticker[1].height = 128.00;
		if (trashSticker[1].onLayout) trashSticker[1].onLayout();
	}
	if (!trashSticker[2] && trashSticker.elementFactory) {
		trashSticker[2] = trashSticker.elementFactory(2,undefined);
	}
	if (trashSticker[2]) {
		BadgePopup_canSticker.call(trashSticker[2] as IBadgePopup_canSticker);
		trashSticker[2].x = 778.75;
		trashSticker[2].y = 266;
		trashSticker[2].width = 127.50;
		trashSticker[2].height = 128.00;
		if (trashSticker[2].onLayout) trashSticker[2].onLayout();
	}
	const lightsoutSticker = this.lightsoutSticker;
	if (!lightsoutSticker[0] && lightsoutSticker.elementFactory) {
		lightsoutSticker[0] = lightsoutSticker.elementFactory(0,undefined);
	}
	if (lightsoutSticker[0]) {
		BadgePopup_lightbulbSticker.call(lightsoutSticker[0] as IBadgePopup_lightbulbSticker);
		lightsoutSticker[0].x = 708.75;
		lightsoutSticker[0].y = 394;
		lightsoutSticker[0].width = 127.50;
		lightsoutSticker[0].height = 128.00;
		if (lightsoutSticker[0].onLayout) lightsoutSticker[0].onLayout();
	}
	if (!lightsoutSticker[1] && lightsoutSticker.elementFactory) {
		lightsoutSticker[1] = lightsoutSticker.elementFactory(1,undefined);
	}
	if (lightsoutSticker[1]) {
		BadgePopup_waterSticker.call(lightsoutSticker[1] as IBadgePopup_waterSticker);
		lightsoutSticker[1].x = 708.75;
		lightsoutSticker[1].y = 394;
		lightsoutSticker[1].width = 127.50;
		lightsoutSticker[1].height = 128.00;
		if (lightsoutSticker[1].onLayout) lightsoutSticker[1].onLayout();
	}
	if (!lightsoutSticker[2] && lightsoutSticker.elementFactory) {
		lightsoutSticker[2] = lightsoutSticker.elementFactory(2,undefined);
	}
	if (lightsoutSticker[2]) {
		BadgePopup_boltSticker.call(lightsoutSticker[2] as IBadgePopup_boltSticker);
		lightsoutSticker[2].x = 708.75;
		lightsoutSticker[2].y = 394;
		lightsoutSticker[2].width = 127.50;
		lightsoutSticker[2].height = 128.00;
		if (lightsoutSticker[2].onLayout) lightsoutSticker[2].onLayout();
	}
	const planterpartySticker = this.planterpartySticker;
	if (!planterpartySticker[0] && planterpartySticker.elementFactory) {
		planterpartySticker[0] = planterpartySticker.elementFactory(0,undefined);
	}
	if (planterpartySticker[0]) {
		BadgePopup_flowerSticker.call(planterpartySticker[0] as IBadgePopup_flowerSticker);
		planterpartySticker[0].x = 854.75;
		planterpartySticker[0].y = 394;
		planterpartySticker[0].width = 127.50;
		planterpartySticker[0].height = 128.00;
		if (planterpartySticker[0].onLayout) planterpartySticker[0].onLayout();
	}
	if (!planterpartySticker[1] && planterpartySticker.elementFactory) {
		planterpartySticker[1] = planterpartySticker.elementFactory(1,undefined);
	}
	if (planterpartySticker[1]) {
		BadgePopup_butterflySticker.call(planterpartySticker[1] as IBadgePopup_butterflySticker);
		planterpartySticker[1].x = 854.75;
		planterpartySticker[1].y = 394;
		planterpartySticker[1].width = 127.50;
		planterpartySticker[1].height = 128.00;
		if (planterpartySticker[1].onLayout) planterpartySticker[1].onLayout();
	}
	if (!planterpartySticker[2] && planterpartySticker.elementFactory) {
		planterpartySticker[2] = planterpartySticker.elementFactory(2,undefined);
	}
	if (planterpartySticker[2]) {
		BadgePopup_sproutSticker.call(planterpartySticker[2] as IBadgePopup_sproutSticker);
		planterpartySticker[2].x = 854.75;
		planterpartySticker[2].y = 394;
		planterpartySticker[2].width = 127.50;
		planterpartySticker[2].height = 128.00;
		if (planterpartySticker[2].onLayout) planterpartySticker[2].onLayout();
	}
	const bg = this.bg;
	BadgePopup_bg.call(this.bg);
	bg.x = 512.25;
	bg.y = 383.75;
	bg.width = 860.50;
	bg.height = 539.50;
	if (bg.onLayout) bg.onLayout();
	const homeButton = this.homeButton;
	BadgePopup_homeButton.call(this.homeButton);
	homeButton.x = 103;
	homeButton.y = 162.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	const badge = this.badge;
	BadgePopup_badge.call(this.badge);
	badge.x = 784;
	badge.y = 386;
	badge.width = 464.00;
	badge.height = 518.00;
	if (badge.onLayout) badge.onLayout();
	const grover = this.grover;
	BadgePopup_grover.call(this.grover);
	grover.x = 386.5;
	grover.y = 568.5;
	grover.width = 431.05;
	grover.height = 713.00;
	if (grover.onLayout) grover.onLayout();
	const elmo = this.elmo;
	BadgePopup_elmo.call(this.elmo);
	elmo.x = 149;
	elmo.y = 696.25;
	elmo.width = 536.00;
	elmo.height = 550.50;
	if (elmo.onLayout) elmo.onLayout();
	const abby = this.abby;
	BadgePopup_abby.call(this.abby);
	abby.x = 145.75;
	abby.y = 626.25;
	abby.width = 361.50;
	abby.height = 606.50;
	if (abby.onLayout) abby.onLayout();
	const oscar = this.oscar;
	BadgePopup_oscar.call(this.oscar);
	oscar.x = 167;
	oscar.y = 601.25;
	oscar.width = 412.00;
	oscar.height = 658.50;
	if (oscar.onLayout) oscar.onLayout();
	return this;
}
function BadgePopup_bg(this: IBadgePopup_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("modalbg.png", 0.500, 0.500);
	return this;
}
function BadgePopup_homeButton(this: IBadgePopup_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
function BadgePopup_badge(this: IBadgePopup_badge) {
	if (this.setLayoutTexture) this.setLayoutTexture("badge.png", 0.500, 0.500);
	return this;
}
function BadgePopup_grover(this: IBadgePopup_grover) {
	if (this.setLayoutTexture) this.setLayoutTexture("grover.png", 0.500, 0.500);
	return this;
}
function BadgePopup_elmo(this: IBadgePopup_elmo) {
	if (this.setLayoutTexture) this.setLayoutTexture("elmo.png", 0.500, 0.500);
	return this;
}
function BadgePopup_abby(this: IBadgePopup_abby) {
	if (this.setLayoutTexture) this.setLayoutTexture("abby.png", 0.500, 0.500);
	return this;
}
function BadgePopup_oscar(this: IBadgePopup_oscar) {
	if (this.setLayoutTexture) this.setLayoutTexture("oscar.png", 0.500, 0.500);
	return this;
}
function BadgePopup_recyclingSticker(this: IBadgePopup_recyclingSticker) {
	if (this.setLayoutTexture) this.setLayoutTexture("recyclingsticker.png", 0.500, 0.500);
	return this;
}
function BadgePopup_bananaSticker(this: IBadgePopup_bananaSticker) {
	if (this.setLayoutTexture) this.setLayoutTexture("bananasticker.png", 0.500, 0.500);
	return this;
}
function BadgePopup_canSticker(this: IBadgePopup_canSticker) {
	if (this.setLayoutTexture) this.setLayoutTexture("cansticker.png", 0.500, 0.500);
	return this;
}
function BadgePopup_lightbulbSticker(this: IBadgePopup_lightbulbSticker) {
	if (this.setLayoutTexture) this.setLayoutTexture("lightbulbsticker.png", 0.500, 0.500);
	return this;
}
function BadgePopup_waterSticker(this: IBadgePopup_waterSticker) {
	if (this.setLayoutTexture) this.setLayoutTexture("watersticker.png", 0.500, 0.500);
	return this;
}
function BadgePopup_boltSticker(this: IBadgePopup_boltSticker) {
	if (this.setLayoutTexture) this.setLayoutTexture("boltsticker.png", 0.500, 0.500);
	return this;
}
function BadgePopup_flowerSticker(this: IBadgePopup_flowerSticker) {
	if (this.setLayoutTexture) this.setLayoutTexture("flowersticker.png", 0.500, 0.500);
	return this;
}
function BadgePopup_butterflySticker(this: IBadgePopup_butterflySticker) {
	if (this.setLayoutTexture) this.setLayoutTexture("butterflysticker.png", 0.500, 0.500);
	return this;
}
function BadgePopup_sproutSticker(this: IBadgePopup_sproutSticker) {
	if (this.setLayoutTexture) this.setLayoutTexture("sproutsticker.png", 0.500, 0.500);
	return this;
}
interface IBadgePopupArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IBadgePopupContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IBadgePopupSprite extends IBadgePopupContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IBadgePopupText extends IBadgePopupContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IBadgePopupPolygon extends Array<number> {
}
interface IBadgePopup {
	readonly trashSticker: IBadgePopupArray<IBadgePopup_recyclingSticker|IBadgePopup_bananaSticker|IBadgePopup_canSticker>;
	readonly lightsoutSticker: IBadgePopupArray<IBadgePopup_lightbulbSticker|IBadgePopup_waterSticker|IBadgePopup_boltSticker>;
	readonly planterpartySticker: IBadgePopupArray<IBadgePopup_flowerSticker|IBadgePopup_butterflySticker|IBadgePopup_sproutSticker>;
	readonly bg: IBadgePopup_bg;
	readonly homeButton: IBadgePopup_homeButton;
	readonly badge: IBadgePopup_badge;
	readonly grover: IBadgePopup_grover;
	readonly elmo: IBadgePopup_elmo;
	readonly abby: IBadgePopup_abby;
	readonly oscar: IBadgePopup_oscar;
}
interface IBadgePopup_bg extends IBadgePopupSprite {
}
interface IBadgePopup_homeButton extends IBadgePopupSprite {
}
interface IBadgePopup_badge extends IBadgePopupSprite {
}
interface IBadgePopup_grover extends IBadgePopupSprite {
}
interface IBadgePopup_elmo extends IBadgePopupSprite {
}
interface IBadgePopup_abby extends IBadgePopupSprite {
}
interface IBadgePopup_oscar extends IBadgePopupSprite {
}
interface IBadgePopup_recyclingSticker extends IBadgePopupSprite {
}
interface IBadgePopup_bananaSticker extends IBadgePopupSprite {
}
interface IBadgePopup_canSticker extends IBadgePopupSprite {
}
interface IBadgePopup_lightbulbSticker extends IBadgePopupSprite {
}
interface IBadgePopup_waterSticker extends IBadgePopupSprite {
}
interface IBadgePopup_boltSticker extends IBadgePopupSprite {
}
interface IBadgePopup_flowerSticker extends IBadgePopupSprite {
}
interface IBadgePopup_butterflySticker extends IBadgePopupSprite {
}
interface IBadgePopup_sproutSticker extends IBadgePopupSprite {
}
